import React, { Component } from 'react'

export class SuccessPartially extends Component {
	render() {
		return (
			<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_1649_990)">
					<path d="M32 64C14.3264 64 0 49.6736 0 32C0 14.3264 14.3264 0 32 0C49.6736 0 64 14.3264
					64 32C64 49.6736 49.6736 64 32 64ZM32 57.6C38.7895 57.6 45.301 54.9029 50.1019 50.1019C54.9029
					45.301 57.6 38.7895 57.6 32C57.6 25.2105 54.9029 18.699 50.1019 13.8981C45.301 9.09714 38.7895
					6.4 32 6.4C25.2105 6.4 18.699 9.09714 13.8981 13.8981C9.09714 18.699 6.4 25.2105 6.4 32C6.4 38.7895
					9.09714 45.301 13.8981 50.1019C18.699 54.9029 25.2105 57.6 32 57.6ZM32 16C32.8487 16 33.6626 16.3371
					34.2627 16.9373C34.8629 17.5374 35.2 18.3513 35.2 19.2V35.2C35.2 36.0487 34.8629 36.8626 34.2627
					37.4627C33.6626 38.0629 32.8487 38.4 32 38.4C31.1513 38.4 30.3374 38.0629 29.7373 37.4627C29.1371
					36.8626 28.8 36.0487 28.8 35.2V19.2C28.8 18.3513 29.1371 17.5374 29.7373 16.9373C30.3374 16.3371
					31.1513 16 32 16ZM32 48C31.1513 48 30.3374 47.6629 29.7373 47.0627C29.1371 46.4626 28.8 45.6487
					28.8 44.8C28.8 43.9513 29.1371 43.1374 29.7373 42.5373C30.3374 41.9371 31.1513 41.6 32 41.6C32.8487
					41.6 33.6626 41.9371 34.2627 42.5373C34.8629 43.1374 35.2 43.9513 35.2 44.8C35.2 45.6487 34.8629
					46.4626 34.2627 47.0627C33.6626 47.6629 32.8487 48 32 48Z" fill="#997704" />
				</g>
				<defs>
					<clipPath id="clip0_1649_990">
						<rect width="64" height="64" fill="white" />
					</clipPath>
				</defs>
			</svg>

		)
	}
}

export default SuccessPartially
